export default {
  app: {
    id: 'leslie-express-dashboard',
    server: {
      url: 'https://lesliesexpress.ph'
    }
  }
}